export default __webpack_public_path__ + "static/media/filter.1ffab2cf.svg";